import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import '../../styles/TyPage.scss';
import logo from "../../assets/logo.png";
import FailedTransaction from './FailedTransaction';
import PageLoading from '../../components/PageLoading'; 

const API_ENDPOINT = process.env.REACT_APP_BD_API_ENDPOINT;
const APP_KEY = process.env.REACT_APP_BD_APP_KEY!;
const PUB_KEY = process.env.REACT_APP_BD_PUB!;
const API_SECRET = process.env.REACT_APP_BD_SECRET!;
const encodeCredentials = btoa(`${PUB_KEY}:${API_SECRET}`);

const Confirmation = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const transactionId = params.get('transactionId');
  const [transaction, setTransaction] = useState<any>(null);
  const [loadingTransaction, setLoadingTransaction] = useState(true);

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const res = await fetch(`${API_ENDPOINT}/api/v2/transactions/${transactionId}`, {
          method: 'GET',
          headers: {
            'X-App': APP_KEY,
            'Authorization': `Bearer ${encodeCredentials}`,
            'Content-Type': 'application/json',
          },
        });
        const result = await res.json();
        const data = result.data;

       if (data && data.status === 'Succeeded') {
  setTransaction(data);

  const event_url = `${window.location.origin}/confirmation?merchantReferenceNumber=${data.reference_id || transactionId}&transactionId=${transactionId}&status=${data.status}`;
          console.log("Event URL:", event_url);

        } else {
          setTransaction(null);
        }

      } catch (err) {
        console.error('Failed to fetch transaction:', err);
      } finally {
        setLoadingTransaction(false);
      }
    };

    if (transactionId) {
      fetchTransaction();
    }
  }, [transactionId]);

  if (loadingTransaction) return <PageLoading />;
  if (!transaction) return <FailedTransaction />;

  return (
    <div className="ty-container">
      <div className="ty-content">
        <Link to="/">
        <img src={logo} alt="Logo" className="ty-logo" />
        </Link>

        <h2 className="ty-title">Ticket Purchased Confirmed!</h2>
        <p className="ty-subtext">
          Your ticket purchased has been successfully confirmed.
          <br />
          Reference No.: <strong>{transactionId}</strong>
        </p>

        <p className='ty-reminder'>
          Please make sure to download your ticket before closing this page.
        </p>
        {/* {transactionId && (
          <button
            onClick={() => downloadPDF(transactionId)}
            className="ty-button"
            disabled={loading}
          >
            {loading ? 'Generating PDF...' : 'Download Ticket'}
          </button>
        )} */}

        <div className="ty-discover">
          <p className="ty-discover-title">Discover more with Gottit!</p>
          <p className="ty-discover-text">
            Sign up for free and explore exclusive products, offers, and more — only on Gottit
          </p>
          <a
            href="https://gottit.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="ty-button"
          >
            Visit Gottit.io
          </a>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
